import PropTypes from 'prop-types';
import React from 'react';
import Pixel, {
    EmitMetric,
} from '../../Analytics/VisibilityPixel/VisibilityPixel';
import CompaniesModal from '../../CallToAction/LeftRailCTA/CompaniesModal/CompaniesModal';
import Button from '../../Input/Button/Button';
import CommonCardShell from '../../Layout/CommonCardShell/CommonCardShell';
import CompanyReviewListItem from '../../Layout/ListSection/CompanyReviewListItem/CompanyReviewListItem';
import ListSection from '../../Layout/ListSection/ListSection';
import './EmployerReviewsBox.scss';

export default class EmployerReviewsBox extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        pageProps: PropTypes.object,
        hasFollowingCompanies: PropTypes.bool,
        reviews: PropTypes.arrayOf(
            PropTypes.shape({
                reviewId: PropTypes.number,
                company: PropTypes.shape({
                    companyId: PropTypes.number,
                    companyName: PropTypes.string,
                    companyUrl: PropTypes.string,
                    logo: PropTypes.shape({
                        src: PropTypes.string,
                        alt: PropTypes.string,
                    }),
                    rating: PropTypes.oneOfType([
                        PropTypes.string,
                        PropTypes.number,
                    ]),
                    companyEndpoint: PropTypes.string,
                }),
                comment: PropTypes.string,
                reviewUrl: PropTypes.string,
            })
        ),
        title: PropTypes.string,
        wrapAuth: PropTypes.func,
        isLoggedIn: PropTypes.func,
        toggleJobReviewSurvey: PropTypes.func,
        modalTrigger: PropTypes.func,
        metrics: PropTypes.object,
    };

    static defaultProps = {
        title: 'Employer Reviews',
        hasFollowingCompanies: false,
        reviews: [],
        metrics: {
            clickTrigger: 'right-rail-company-click',
        },
    };

    openCompaniesModal = () => {
        this.props.modalTrigger('CompaniesModal');
        EmitMetric({
            misc_event_count: 1,
            misc_event_type: this.props.metrics.clickTrigger,
        });
    };

    onClickReview = (url) => {
        EmitMetric({
            misc_event_count: 1,
            misc_event_type: this.props.metrics.clickTrigger,
        });
        window.location = url;
    };

    render() {
        return (
            <CommonCardShell>
                <div className="component-RightRail-EmployerReviewsBox">
                    <ListSection title={this.props.title}>
                        {this.props.reviews && this.props.reviews.length
                            ? this.props.reviews.map((review, idx) => {
                                  const noUnderlineClass =
                                      idx === this.props.reviews.length - 1
                                          ? 'no-underline'
                                          : '';
                                  const link = `/company-overview/${review.company.companyEndpoint}`;
                                  return (
                                      <a
                                          key={`review-${idx}`}
                                          className={`${noUnderlineClass} company-list-link`}
                                          onClick={() =>
                                              this.onClickReview(link)
                                          }
                                      >
                                          <CompanyReviewListItem
                                              {...review}
                                              metrics={this.props.metrics}
                                          />
                                      </a>
                                  );
                              })
                            : null}
                        <div className="leave-a-review-button-div employer-review-button-div">
                            <Button
                                type={'solid'}
                                value={'Leave a review'}
                                onClick={() => {
                                    this.props.modalTrigger();
                                    this.props.toggleJobReviewSurvey(true);
                                    EmitMetric({
                                        misc_event_count: 1,
                                        misc_event_type: this.props.metrics
                                            .clickTrigger,
                                    });
                                }}
                            />
                        </div>
                        {!!(
                            this.props.pageProps &&
                            this.props.pageProps.session &&
                            this.props.pageProps.session.username &&
                            this.props.pageProps.session.username.length &&
                            this.props.hasFollowingCompanies
                        )
                            ? null
                            : this.props.wrapAuth(
                                  'CreateContent',
                                  <div className="follow-company-button-div employer-review-button-div">
                                      <Button
                                          type={'tertiary-blue-gray'}
                                          value={'Follow a company'}
                                          onClick={() =>
                                              this.props.isLoggedIn()
                                                  ? this.openCompaniesModal()
                                                  : null
                                          }
                                      />
                                  </div>,
                                  { login_trigger: 'create-content' }
                              )}
                        {this.props.metrics.impression && (
                            <Pixel
                                metrics={{
                                    misc_event_type: this.props.metrics
                                        .impression,
                                    impression: 1,
                                }}
                            />
                        )}
                    </ListSection>
                </div>
            </CommonCardShell>
        );
    }
}
